import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { StoreState, useAppDispatch } from 'store';
import { authActions } from 'features/auth/redux/auth.actions';
import { SignInPayload } from 'features/auth/api/types';

export default function useAuth() {
  const dispatch = useAppDispatch();
  const state = useSelector((state: StoreState) => state.auth);

  const checkAuth = useCallback(() => {
    dispatch(authActions.checkAuthRequest());
  }, [dispatch]);

  const signIn = useCallback(
    (data: SignInPayload) => {
      dispatch(authActions.signInRequest(data));
    },
    [dispatch]
  );

  const signOut = useCallback(() => {
    dispatch(authActions.signOutRequest());
  }, [dispatch]);

  const clearErrors = useCallback(() => {
    dispatch(authActions.clearErrors());
  }, [dispatch]);

  return {
    state,
    checkAuth,
    signIn,
    signOut,
    clearErrors,
  };
}
